import { CheckIcon } from 'lucide-react';
import { DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '../ui/button';
import { Avatar, AvatarFallback, AvatarImage } from '../ui/avatar';
import { useTranslation } from 'react-i18next';

type UserInfo = {
  pictureUrl?: string;
  firstName?: string;
  lastName?: string;
};

type PaymentValidationProps = {
  workspaceName?: string;
  selectedPlanKey: string | null;
  user: UserInfo | null;
  onBackToDashboard: () => void;
  confirmLabel?: string;
};

export default function PaymentValidation({
  workspaceName,
  selectedPlanKey,
  user,
  onBackToDashboard,
  confirmLabel,
}: PaymentValidationProps) {
  const { t } = useTranslation('billing');

  // Le back renvoie la clé technique du forfait : on la traduit pour l'afficher, sans quoi
  // « Enterprise » apparaît tel quel dans une interface française.
  const planName = selectedPlanKey
    ? t(`planSection.plans.${selectedPlanKey.toLowerCase()}.shortName`, {
        defaultValue: selectedPlanKey,
      })
    : '';

  return (
    <>
      <DialogHeader>
        <DialogTitle>{t('paymentValidation.titleSuccess')}</DialogTitle>
      </DialogHeader>

      <div className="space-y-4">
        <div className="flex justify-between p-4 rounded-[20px] bg-[#1F1F1F]/3">
          <div className="flex gap-4">
            <Avatar className="size-12">
              <AvatarImage src={user?.pictureUrl} />
              <AvatarFallback>
                {user?.firstName?.charAt(0) ?? ''}
                {user?.lastName?.charAt(0) ?? ''}
              </AvatarFallback>
            </Avatar>
            <div>
              <p className="text-xl font-medium">{workspaceName}</p>
              <p className="text-text-secondary text-base">
                {t('paymentValidation.plan')} <span className="text-highlighted">{planName}</span>
              </p>
            </div>
          </div>

          <CheckIcon className="size-6 text-success" />
        </div>

        <p className="text-secondary text-sm">
          {t('paymentValidation.descriptionPrefix', { planName })}
          <br />
          <br />
          {t('paymentValidation.descriptionSuffix', { planName })}
        </p>

        <Button className="w-full" onClick={onBackToDashboard}>
          {confirmLabel ?? t('paymentValidation.backToDashboard')}
        </Button>
      </div>
    </>
  );
}
